import { FuseAnimate } from "@fuse";
import _ from "@lodash";
import { withStyles } from "@material-ui/core";
import XAPPButton from "app/Core/Components/Button/XAPPButton";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import * as AppActions from "app/store/actions";
import clsx from "clsx";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import ReactTable from "react-table";
import { bindActionCreators } from "redux";
import * as Actions from "./Store/Actions/TarefaApontamentoActions";
import TarefaApontamentoItemDialog from "./TarefaApontamentoItemDialog";

const styles = theme => ({
    root: {
        color: theme.palette.text.primary,
        visibility: "visible !important"
    },
    addButton: {
        position: "absolute",
        right: 20,
        bottom: 60,
        zIndex: 99
    }
});

class TarefaApontamentoItens extends XAPPComponent {

    state = {
        open: null,
    };

    getApontamentos = () => {
        let AArray = [];
        const { Apontamento } = this.props;
        if (!_.isNull(Apontamento.itens)) {
            Apontamento.itens.forEach(item => {
                if (_.isNull(item.idtarefaprocessoapontamentoitem) || (item.idtarefaprocessoapontamentoitem > 0 && item.statusregistro === 1)) {
                    AArray.push(item);
                }
            });
        }
        return AArray;
    };

    getColumns = () => {
        var AResponse = [];
        const { save, Apontamento, xappRouteParams, idtarefaprocesso, handleChangeItens } = this.props;
        const Columns = [
            {
                Header: "ID",
                accessor: "idtarefaprocessoapontamentoitem",
                width: 100,
                className: "justify-center",
                natureza: []
            },
            {
                Header: "Nome",
                accessor: "nome",
                width: 300,
                className: "justify-center",
                natureza: [0, 2, 3, 4, 6, 7, 15, 16, 18]
            },
            {
                Header: "Quantidade",
                accessor: "quantidade",
                width: 100,
                className: "justify-center",
                natureza: [0, 2, 3, 4, 6, 7, 15, 16, 18]
            },
            {
                Header: "Valor",
                accessor: "valordescricao",
                width: 100,
                className: "justify-center",
                natureza: [0, 1, 2, 3, 4, 5, 6, 7, 18]
            },
            {
                Header: "Desconto",
                accessor: "descontodescricao",
                width: 100,
                className: "justify-center",
                natureza: [0, 3, 4, 6, 7, 18]
            },
            {
                Header: "Valor total",
                accessor: "valortotaldescricao",
                width: 100,
                className: "justify-center",
                natureza: [0, 3, 4, 6, 7, 18]
            },
            {
                Header: "Vencimento",
                accessor: "vencimentodescricao",
                width: 150,
                className: "justify-center",
                natureza: [1, 5]
            },
            {
                Header: "Forma de pagamento",
                accessor: "idpessoaformularioformapagamentodescricao",
                width: 200,
                className: "justify-center",
                natureza: [1, 5]
            },
            {
                Header: "Categoria",
                accessor: "idpessoaformulariocategoriadescricao",
                width: 150,
                className: "justify-center",
                natureza: []
            },
            {
                Header: "Baixar",
                width: 60,
                natureza: [],
                className: "justify-center",
                Cell: row => (
                    <div className="flex items-center">
                        {row.original.baixa === null ? (
                            <XAPPButton
                                tooltip={{ "title": "Baixar", "placement": "top" }}
                                type="Icon"
                                className=""
                                variant="contained"
                                color="primary"
                                onClick={(ev) => {
                                    ev.stopPropagation();
                                    save("BAIXARITEM", row.original, xappRouteParams, Apontamento.idtarefaprocessoapontamento);
                                }}
                                iconProps={"justify-center"}
                                icon={"cifrao"}
                            />
                        ) : (
                            <XAPPButton
                                tooltip={{ "title": "Estornar", "placement": "top" }}
                                type="Icon"
                                className=""
                                variant="contained"
                                color="primary"
                                onClick={(ev) => {
                                    ev.stopPropagation();
                                    save("ESTORNARBAIXAITEM", row.original, xappRouteParams, Apontamento.idtarefaprocessoapontamento);
                                }}
                                iconProps={"justify-center"}
                                icon={"return"}
                            />
                        )}
                    </div>
                )
            },
            {
                Header: "Remover",
                width: 120,
                className: "justify-center",
                natureza: [0, 3, 4, 7, 15, 16, 18],
                Cell: row => (
                    <div className="flex items-center">
                        <XAPPButton
                            tooltip={{ "title": "Remover", "placement": "top" }}
                            type="Icon"
                            className="p-6"
                            variant="contained"
                            color="primary"
                            onClick={(ev) => {
                                ev.stopPropagation();
                                handleChangeItens(row.original, "REMOVER");
                            }}
                            iconProps={"justify-center"}
                            icon={"close"}
                        />
                    </div>
                )
            },
            {
                Header: "Baixar",
                width: 120,
                className: "justify-center",
                natureza: [0],
                Cell: row => (
                    <div className="flex items-center">
                        {row.original.statusregistro !== 0 &&
                            <XAPPButton
                                tooltip={{ "title": "Baixar", "placement": "top" }}
                                type="Icon"
                                className="p-6"
                                variant="contained"
                                color="primary"
                                onClick={(ev) => {
                                    ev.stopPropagation();
                                    this.openDialog({ idtarefaprocesso: idtarefaprocesso, ...row.original });
                                    //save("BAIXARITEMPEDIDO", row.original, xappRouteParams, Apontamento.idtarefaprocessoapontamento);
                                }}
                                iconProps={"justify-center"}
                                icon={"done"}
                            />
                        }
                    </div>
                )
            }
        ];

        Columns.forEach(item => {
            if (item.natureza.includes(Apontamento.natureza)) {
                AResponse.push(item);
            }
        });
        return AResponse;
    };

    openDialog = (_AValue) => {
        this.setState({ open: _AValue });
    };

    render() {
        const { classes, Apontamento, handleChangeItens, xappRouteParams, profissional } = this.props;
        const form = this.state;
        return (
            <React.Fragment>
                <FuseAnimate animation="transition.slideUpIn" delay={300}>
                    <ReactTable
                        className={clsx(classes.root, " -striped -highlight border-0")}
                        key={Date.now()}
                        getTrProps={(state, rowInfo) => {
                            return {
                                className: "cursor-pointer",
                                onClick: () => this.openDialog(rowInfo.original)
                            };
                        }}
                        data={this.getApontamentos()}
                        columns={this.getColumns()}
                        defaultPageSize={!_.isNull(Apontamento.itens) && Apontamento.itens.length > 5 ? Apontamento.itens.length : 5}
                        noDataText="Não existem registros cadastrados!"
                        showPagination={false}
                    />
                </FuseAnimate>
                {[0, 4].includes(Apontamento.natureza) &&
                    <XAPPButton
                        className={clsx(classes.addButton, "text-white mt-12")}
                        type="Fab"
                        id={"fab-add-apontamento-item"}
                        variant="contained"
                        color="primary"
                        iconProps="text-20"
                        onClick={() => this.openDialog({ idtarefaprocessoapontamentoitem: null })}
                        icon={"add"}
                        key={"btnNovoApontamentoItem"}
                    />
                }
                <TarefaApontamentoItemDialog
                    xappRouteParams={xappRouteParams}
                    open={form.open}
                    Apontamento={Apontamento}
                    openDialog={this.openDialog}
                    handleChangeItens={handleChangeItens}
                    profissional={profissional}
                />
            </React.Fragment>
        );
    }
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        save: Actions.save,
        showMessage: AppActions.showMessage,
    }, dispatch);
}

function mapStateToProps({ TarefaApontamento }) {
    return {
        TarefaApontamento: TarefaApontamento,
    };
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(TarefaApontamentoItens)));
